// Module
var code = "<p>Enable this setting to allow your respondents to access the collected results in real-time after they&#39;ve submitted their response.</p> <p><strong>Note:</strong> To protect your participants, input text fields are excluded in the results.</p> ";
// Exports
module.exports = code;